export default __webpack_public_path__ + "static/media/icon_app.245d53c8.svg";